import { Box, Container, useMediaQuery } from '@mui/material'
import { Outlet } from 'react-router-dom'
import AlumeLogoInvertido from '@/assets/images/logo-alume-invertido.svg'
import AlumeLogo from '@/assets/images/logo-alume.svg'
import { usePlatform } from '@/hooks'

export function SessionPage() {
  const { isAndroid, isIOS } = usePlatform()
  const isDesktop = useMediaQuery('(min-width: 600px)')

  return (
    <Box>
      <Box
        p={3}
        style={{
          display: isDesktop ? 'none' : 'flex',
          position: isIOS ? 'fixed' : 'sticky',
          top: 0,
          left: 0,
          justifyContent: 'flex-end',
          width: '100%',
          backgroundColor: 'white',
          paddingTop: isAndroid ? 40 : undefined,
        }}
      >
        <img src={AlumeLogo} alt="Alume" width={120} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Container
          component={'main'}
          maxWidth={'lg'}
          sx={{
            alignSelf: 'center',
            paddingTop: isIOS ? 10 : 4,
          }}
        >
          <Outlet />
        </Container>
        <Box
          sx={{
            display: isDesktop ? 'flex' : 'none',
            backgroundColor: '#004851',
            height: '100vh',
            width: '100%',
          }}
        >
          <img
            src={AlumeLogoInvertido}
            alt="Alume"
            width={120}
            style={{ margin: 'auto' }}
          />
        </Box>
      </Box>
    </Box>
  )
}
